module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAPCAYAAADZCo4zAAAA50lEQVQoU23RvU7DQAwAYPveo08CA03ucieqMLRSxZMws8OAkGDrCAMVKxLnJOrMoyBgTgbbKBFFSXse7U+Wf5CIPlT1uiiKN0gE1nWdicgrAFw6594PDfaJPULEtbWWxmgAfVRV5VT1xRizyvO82ef/wRiJyMp7P6AJ+ENBRJ4Rcemc2x2BHjVNc87MT4h4kQQ9ijFuEXGWBER0AwALRJynZrgFgMDMmff+83CLOxGxqjoUJ1sQ0b2qnnVdl5Vl+TW5AxE9AMBp27b5uDh0IKJHADhh5nkI4efoFzHGK2PMxlr7nfrmL9t/csXL5egUAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/common/images/index/back1.png
// module id = 5Jop
// module chunks = 0